import { render, staticRenderFns } from "./DsTree.vue?vue&type=template&id=1f9608b1&scoped=true&xmlns%3Ael-col=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./DsTree.vue?vue&type=script&lang=js"
export * from "./DsTree.vue?vue&type=script&lang=js"
import style0 from "./DsTree.vue?vue&type=style&index=0&id=1f9608b1&lang=scss&scoped=true"
import style1 from "./DsTree.vue?vue&type=style&index=1&id=1f9608b1&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9608b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f9608b1')) {
      api.createRecord('1f9608b1', component.options)
    } else {
      api.reload('1f9608b1', component.options)
    }
    module.hot.accept("./DsTree.vue?vue&type=template&id=1f9608b1&scoped=true&xmlns%3Ael-col=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml", function () {
      api.rerender('1f9608b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/datasource/DsTree.vue"
export default component.exports